import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Validators, FormBuilder } from '@angular/forms';

@Component({
  selector: 'app-deliver-order-form',
  templateUrl: './deliver-order-form.component.html',
  standalone: false
})
export class DeliverOrderFormComponent {
  @Output() submitted = new EventEmitter<string>();
  @Output() cancelled = new EventEmitter<void>();

  form = this.fb.group({
    deliveryCode: ['', Validators.required],
  });

  constructor(private fb: FormBuilder) { }

  submit() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    this.submitted.emit(this.form.value.deliveryCode);
  }

  cancel() {
    this.cancelled.emit();
  }

  setInvalidCode() {
    this.form.get('deliveryCode')?.setErrors({ invalidCode: true });
  }


}
